/**
 * Tooltip — Anker + beschreibender Text fuer die UI-Komponentenbibliothek (Story 0.3)
 *
 * a11y-Entscheidung: Der Tooltip-Text liegt IMMER im DOM und ist per
 * aria-describedby mit dem Trigger verknuepft. Sichtbar wird er per CSS bei
 * Hover/Fokus (siehe ui.css). Dadurch ist er fuer Screenreader unabhaengig
 * von Maus-Hover erreichbar und Tastaturnutzer erhalten ihn ueber den Fokus
 * des Triggers (`tabIndex={0}` am Trigger noetig — StatusChip setzt das).
 */
import { useId, type ReactNode } from 'react'

export type TooltipProps = {
  /** Beschreibender Text (wird via aria-describedby verknuepft). */
  text: ReactNode
  /**
   * Render-Prop fuer den Trigger. Bekommt die id des Tooltips, damit der
   * Trigger sie als aria-describedby setzen kann.
   */
  children: (describedById: string) => ReactNode
  className?: string
}

export function Tooltip({ text, children, className = '' }: TooltipProps) {
  const tipId = `ui-tip-${useId().replace(/:/g, '')}`

  return (
    <span className={`ui-tip-anchor ${className}`.trim()}>
      {children(tipId)}
      <span id={tipId} role="tooltip" className="ui-tip">
        {text}
      </span>
    </span>
  )
}
